import { must } from './dom';

/**
 * A modal that closes on its backdrop, its close button, and Escape.
 */
export class Overlay {
  private readonly root: HTMLElement;

  constructor(
    private readonly id: string,
    closeButtonId: string,
    /** Fires on the closings no button answers for — backdrop and Escape. */
    private readonly onDismiss?: () => void,
  ) {
    this.root = must(id);
    must(closeButtonId).addEventListener('click', () => this.close());
    this.root.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).id === this.id) this.dismiss();
    });
  }

  get isOpen(): boolean {
    return this.root.classList.contains('show');
  }

  open(): void {
    this.root.classList.add('show');
  }

  close(): void {
    this.root.classList.remove('show');
  }

  /** Close plus the dismiss hook. Button and programmatic paths use close(). */
  dismiss(): void {
    this.close();
    this.onDismiss?.();
  }
}

/** Wire Escape once, closing whichever overlay is on top. */
export function closeOnEscape(overlays: Overlay[]): void {
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    for (const o of overlays) {
      if (o.isOpen) {
        o.dismiss();
        return;
      }
    }
  });
}
